<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-delete"
      title="Delete User"
      ok-only
      ok-title="Delete"
      @ok="deleteItem"
    >
      <b-card-text>
        <h5>Are You Sure You Want to Remove This Employee Salary</h5>
        If you want to remove this Employee Salary, click the button below.
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="createMode ? 'Add Employee Salary' : 'Edit Employee Salary'"
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group label="Employee Salary" label-for="name">
              <b-form-input
                v-model="EditForm.full_name"
                placeholder="Employee Full Name"
              />
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group label="Employee Job Title" label-for="name">
              <b-form-input
                v-model="EditForm.job_title"
                placeholder="Employee Job Title"
              />
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group label="Employee Base Salary" label-for="name">
              <b-form-input
                type="number"
                v-model="EditForm.base_salary"
                placeholder="Employee Base Salary"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card title="Employees Salary">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h1>
              {{ $t("employee.employee") }} : {{ employeeData.full_name }}
            </h1>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <!-- <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getEmployeesSalaryList()">
              Search <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row> -->
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>Employees Salary Table</h2>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(salary_month)="data">
            <span>{{ $t(`months.${data.item.salary_month}`) }}</span>
          </template>
          <template #cell(status)="data">
            <!-- {{ data.item.salary? data. }} -->
            <span
              v-if="data.item.status == true"
              class="text-success"
              style="font-size: 17px; font-weight: bold"
            >
              {{ $t("employee.salary-recieved") }}</span
            >
            <span
              v-if="data.item.status == false"
              style="font-size: 17px; font-weight: bold"
              class="text-warning"
            >
              {{ $t("employee.salary-not-recieved") }}</span
            >
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->

              <b-button
                @click="deleteModel(data.item)"
                pill
                variant="outline-danger"
                v-if="
                  $store.state.app.permissions.includes('delete-employeeSalary')
                "
                >Delete</b-button
              >
              <b-button
                variant="outline-warning"
                pill
                class="mx-1"
                v-if="
                  $store.state.app.permissions.includes('update-employeeSalary')
                "
                @click="show(data.item)"
                >Edit</b-button
              >
              <b-button
                v-if="!data.item.status"
                variant="outline-success"
                pill
                class="mx-1"
                @click="DespenseSalary(data.item)"
                >{{ $t("employee.despense-salary") }}</b-button
              >
              <!-- Dropdown -->
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Employees Salary</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getEmployeesSalaryList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import permissionChecker from "@/mixins/permissionChecker";

export default {
  mixins: [permissionChecker],

  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    AutoComplete,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      employeeData: "",
      EditForm: {
        full_name: "",
        job_title: "",
        base_salary: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        full_name: "",
        job_title: "",
        base_salary: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        {
          key: "total_salary",
          label: this.$t("employee.salary"),
          sortable: true,
        },

        {
          key: "additional_salary",
          label: this.$t("employee.add-salary"),
          sortable: true,
        },

        {
          key: "deduction_salary",
          label: this.$t("employee.deducation-salary"),
          sortable: true,
        },
        { key: "salary_date", sortable: true },
        { key: "status", label: this.$t("employee.status"), sortable: true },
        { key: "salary_month", sortable: true },
        { key: "Actions" },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getEmployeesSalaryList();
    this.getEmployee();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          full_name: "",
          job_title: "",
          base_salary: "",

          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.full_name = item.full_name;
        this.EditForm.job_title = item.job_title;
        this.EditForm.base_salary = item.base_salary;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getEmployeesSalaryList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/employeeSalary?page=${this.page}&take=${this.take}&sort=-id&filter[employee_id]=${this.$route.params.id}`;

      // if (this.employee) {
      //   url += `&filter[employee_id]=${this.employee}`;
      // }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },
    async getEmployee() {
      this.loading = true;
      let url = `/employees/${this.$route.params.id}`;
      await this.getList(url);
      this.employeeData = this.all_data;
    },
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/employeeSalary/${this.deleteForm.id}`)
        .then((response) => {
          this.getEmployeesSalaryList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/employeeSalary`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getEmployeesSalaryList();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/employeeSalary/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getEmployeesSalaryList();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    DespenseSalary(item) {
      (this.params.form = { employee_ids: item.employee_id }),
        (this.params.path = `/dispense/employeeSalary/${item.id}`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            this.getEmployeesSalaryList();
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Success",
                variant: "success",
                text: "Salary Despensed Successfuly",
              },
            });
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                variant: "danger",
                text: "Something Went Wrong!",
              },
            });
          });
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
